import { render, staticRenderFns } from "./Info_sign.vue?vue&type=template&id=491b599c&scoped=true&"
import script from "./Info_sign.vue?vue&type=script&lang=js&"
export * from "./Info_sign.vue?vue&type=script&lang=js&"
import style0 from "./Info_sign.vue?vue&type=style&index=0&id=491b599c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "491b599c",
  null
  
)

export default component.exports